import type { TranslationKeys } from './index';

export const pl: TranslationKeys = {
  login_hi: 'Miło Cię widzieć! 👋',
  login_title: 'Zaloguj się',
  login_label: 'Logowanie',
  login_title2: 'Zaloguj się do konta pacjenta',
  login_choose: 'Wpisz swój numer telefonu, a my wyślemy Ci kod SMS',
  login_no_password_hint: 'Logujesz się bez hasła — szybko i bezpiecznie',
  phone_placeholder: 'Telefon*',
  login_sub_email: 'Wpisz adres e-mail i hasło',
  forgot: 'Nie pamiętasz hasła?',
  login_by_phone: 'Skorzystaj z logowania przez telefon',
  or: 'lub',
  password: 'Hasło',
  login_btn: 'Zaloguj się',
  cont_google: 'Kontynuuj z Google',
  cont_apple: 'Kontynuuj z Apple',
  no_account: 'Nie masz konta?',
  no_account_sub: 'Zarejestruj się — kolejne zamówienia złożysz szybciej, a wizyty i dokumenty masz w jednym miejscu',
  create_account: 'Utwórz konto',
  reg_title: 'Utwórz konto',
  reg_sub: 'Podaj swoje dane, aby założyć konto pacjenta.',
  firstname: 'Imię',
  lastname: 'Nazwisko',
  id_doc: 'PESEL lub paszport',
  pesel: 'PESEL',
  passport: 'Paszport',
  reg_btn: 'Załóż konto',
  consent1: 'Akceptuję Regulamin oraz Politykę Prywatności',
  consent2: 'Wyrażam zgodę na przetwarzanie moich danych w celu realizacji usług medycznych.',
  reg_phone_title: 'Utwórz konto',
  reg_phone_sub: 'Wpisz swój numer telefonu, a my wyślemy Ci kod SMS',
  reg_firstname: 'Imię',
  reg_lastname: 'Nazwisko',
  consent1_text: 'Akceptuję <a href="/regulamin/">Regulamin</a> oraz <a href="/polityka-prywatnosci/">Politykę Prywatności</a>',
  consent2_text: 'Wyrażam zgodę na przetwarzanie moich danych w celu realizacji usług medycznych',
  no_account_yet_msg: 'Konto pacjenta utworzymy automatycznie po pierwszej opłacie — wtedy zalogujesz się kodem SMS. Złóż zamówienie poniżej.',
  login_no_account_msg: 'Nie znaleziono konta z tym numerem telefonu. Przejdź do rejestracji',
  err_firstname_empty: 'Podaj imię',
  err_lastname_empty: 'Podaj nazwisko',
  err_consent_required: 'Wymagana zgoda',
  reg_login_link: 'Mam już konto — zaloguj się',
  otp_title: 'Wpisz kod SMS',
  otp_sub: 'Wysłaliśmy 4-cyfrowy kod na Twój numer telefonu',
  confirm: 'Potwierdź',
  resend: 'Wyślij kod ponownie',
  phone_label: 'Numer telefonu',
  send_sms_btn: 'Wyślij kod SMS',
  change_number: 'Zmień numer',
  otp_sent_hint: 'Wysłaliśmy 4-cyfrowy kod na Twój numer telefonu {phone}',
  resend_timer: 'Wyślij ponownie ({time})',
  err_phone_empty: 'Podaj numer telefonu',
  err_phone_format: 'Nieprawidłowy format numeru telefonu',
  err_sms_failed: 'Nie udało się wysłać kodu. Spróbuj ponownie',
  err_otp_invalid: 'Kod jest nieaktualny',
  err_otp_expired: 'Kod wygasł — wyślij nowy',
  err_otp_rate_limit: 'Zbyt wiele prób. Odczekaj minutę',
  reset_pw_title: 'Zresetuj hasło',
  reset_pw_sent: 'Jeśli konto istnieje, wysłaliśmy link',
  login_with_sms: 'Zaloguj się kodem SMS',
  login_with_email: 'Zaloguj się e-mailem i hasłem',
  err_network: 'Wystąpił błąd sieci. Jeśli otrzymałeś kod SMS, przejdź dalej.',
  err_fill_all_to_enter_code: 'Wypełnij poprawnie wszystkie pola, aby móc wpisać kod.',
  err_phone_to_enter_code: 'Podaj numer telefonu, aby móc wpisać kod.',
  btn_have_code: 'Mam już kod SMS',
  thanks_title: 'Dziękujemy za opłatę!',
  thanks_sub: 'Twoje zamówienie zostało opłacone. Potwierdzenie wysłaliśmy na Twój adres e-mail. Konto pacjenta jest już gotowe.',
  go_account: 'Przejdź do konta',
  go_back: 'Wróć',
  nav_cons: 'Moje konsultacje',
  nav_cons_short: 'Konsultacje',
  nav_terapia: 'Moja terapia',
  nav_terapia_short: 'Terapia',
  nav_uslugi: 'Usługi',
  nav_uslugi_s: 'Usługi',
  nav_umow: 'Umów się',
  btn_umow: 'Umów',
  nav_doc: 'Dokumenty',
  nav_dane: 'Moje dane',
  logout: 'Wyloguj się',
  greet_title: 'Witaj, {name}! 👋',
  greet_sub: 'Twoje wizyty, dane i dokumenty — wszystko w jednym miejscu',
  cons_actual: 'Aktualne',
  cons_done: 'Zakończone',
  status_upcoming: 'Nadchodząca',
  status_done: 'Zakończona',
  cons_cancelled: 'Anulowane',
  status_cancelled: 'Anulowana',
  status_pending: 'Oczekuję na płatność',
  pay_for_visit: 'Opłać wizytę',
  status_nieudane: 'Nieudane',
  contact_support: 'Skontaktuj się z nami',
  order_no: 'Nr zamówienia',
  show_more: 'Zobacz więcej',
  show_less: 'Zobacz mniej',
  weight: 'Waga',
  by_phone: 'Przez telefon',
  online: 'Online',
  reschedule: 'Przełóż wizytę',
  rebook: 'Umów ponownie',
  empty_cons: 'Nie masz jeszcze żadnych konsultacji',
  empty_cons_sub: 'Tutaj znajdziesz historię swoich wizyt i konsultacji lekarskich.',
  empty_cons_cta: 'Wybierz usługę',
  visit_summary: 'Podsumowanie wizyty',
  cons_empty_tab: 'Brak konsultacji w tej zakładce.',
  cons_show_more: 'Zobacz więcej ({count})',
  cons_collapse: 'Zwiń',
  spec1: 'Lekarz · terapia otyłości',
  spec_tele: 'Lekarz · medycyna rodzinna',
  cons_find_point: 'Znajdź punkt',
  cons_checkup_results_btn: 'Wybierz termin rozmowy',
  cons_find_point_link: 'https://tabletka24.pl/map-synevo/',
  cons_download_referral: 'Pobierz skierowanie',
  terapia_title: 'Twoja terapia, krok po kroku',
  terapia_intro: 'Tu zebraliśmy wszystkie przydatne linki i informacje, które mogą Ci się przydać podczas terapii GLP-1.',
  last_visit: 'Ostatnia wizyta',
  rec_control: 'Zalecana wizyta kontrolna',
  book_control: 'Umów wizytę kontrolną',
  uslugi_title_a: 'Sprawdź, w czym jeszcze możemy Ci pomóc',
  cs_recepta: 'E-Recepta',
  cs_recepta_d: 'Lek na alergię, przeziębienie czy refluks? Odbierz szybko e-receptę online — <strong>59 zł</strong>',
  cs_anty: 'Antykoncepcja',
  cs_anty_d: 'Twoja antykoncepcja zawsze pod ręką — e-recepta online <strong>za 59 zł</strong>',
  cs_l4: 'Zwolnienie (L4)',
  cs_l4_d: 'Źle się czujesz i potrzebujesz odpoczynku? Lekarz wystawi L4 online — <strong>79 zł</strong>',
  cs_tele: 'Teleporada',
  cs_tele_d: 'Infekcja, ból czy przeziębienie? Porozmawiaj z lekarzem online — <strong>79 zł</strong>',
  cs_check: 'Pakiety badań z Synevo',
  cs_check_d: 'Zadbaj o siebie z wyprzedzeniem — pakiety badań <strong>od 259 zł</strong>',
  glp_t: 'Terapia odchudzania (GLP-1)',
  glp_d: 'Próbowałaś już wszystkiego, a waga stoi w miejscu? Kompleksowa terapia GLP-1 <strong>od 199 zł</strong>',
  svc_analizy: 'Badania kontrolne',
  svc_analizy_d: 'Czas sprawdzić, jak organizm reaguje na terapię? Pakiet badań w Synevo — <strong>299 zł</strong>',
  svc_portal: 'Portal o terapii GLP-1',
  svc_portal_d: 'Chcesz zrozumieć, jak działają analogi GLP-1? Wpadnij do portalu wiedzy',
  doc_all: 'Wszystkie',
  doc_recepty: 'Recepty',
  doc_skier: 'Skierowania',
  doc_wyniki: 'Wyniki badań',
  doc_moje: 'Moje pliki',
  doc_l4: 'Zwolnienia',
  doc_zalecenia: 'Zalecenia',
  add_file: 'Dodaj plik',
  empty_doc: 'Tu pojawią się Twoje dokumenty',
  add_file_sub: 'Dodaj dokument — Twój lekarz zobaczy go podczas konsultacji',
  upload_txt: 'Przeciągnij plik lub kliknij tutaj',
  upload_max: '(Maksymalny rozmiar pliku: 100 MB)',
  upload_formats: 'Dostępne formaty: .pdf, .jpg, .jpeg, .png, .doc, .docx',
  upload_blocked_hint: 'Możliwość dodawania plików zostanie odblokowana po pierwszej konsultacji',
  doc_delete_confirm: 'Czy na pewno chcesz usunąć ten plik?',
  doc_title_desktop: 'Dokumenty',
  doc_title_mobile: 'Dokumentacja',
  doc_no_files: 'Brak plików',
  doc_default_name: 'Dokument',
  doc_upload_title: 'Prześlij nowy dokument',
  doc_close: 'Zamknij',
  doc_choose_file: 'Wybierz plik z urządzenia',
  doc_uploaded_file: 'Przesłany plik',
  doc_delete_selected: 'Usuń wybrany plik',
  doc_send_to_doctor: 'Wyślij do lekarza',
  doc_prescription_title: 'Recepta',
  doc_prescription_code: 'Kod e-recepty',
  doc_code: 'Kod',
  doc_pickup_title: 'Jak odebrać lek w aptece?',
  doc_pickup_desc_1: 'Wystarczy podać farmaceucie ',
  doc_pickup_desc_2: 'numer PESEL',
  doc_pickup_desc_3: ' oraz ',
  doc_pickup_desc_4: 'kod recepty',
  doc_prescriptions_heading: 'RECEPTY',
  doc_download_pdf: 'Pobierz (PDF)',
  doc_print_save_pdf: 'Drukuj / Zapisz PDF',
  doc_all_files: 'Wszystkie pliki',
  dane_personal: 'Dane personalne',
  dane_addr: 'Dane adresowe',
  dane_contact: 'Dane kontaktowe',
  security: 'Bezpieczeństwo',
  sex: 'Płeć',
  female: 'Kobieta',
  male: 'Mężczyzna',
  tz: 'Strefa czasowa',
  street: 'Ulica',
  city: 'Miasto',
  country: 'Kraj',
  phone_short: 'Telefon',
  err_phone: 'Nieprawidłowy numer telefonu',
  edit: 'Edytuj',
  change: 'Zmień',
  cancel: 'Anuluj',
  save: 'Zapisz',
  edit_your: 'Edytuj swoje dane',
  resch_title: 'Przełóż wizytę',
  resch_intro: 'Zmieniły się Twoje plany? Przełóż konsultację w kilka kliknięć.',
  resch_current: 'Twój nowy termin',
  resch_doctor: 'Wybierz lekarza',
  resch_pick: 'Wybierz termin',
  resch_confirm: 'Potwierdź nowy termin',
  resch_ok_t: 'Termin przełożony',
  resch_ok_s: 'Twoja wizyta została przeniesiona. Potwierdzenie wysłaliśmy na e-mail',
  back_cons: 'Wróć do konsultacji',
  toast_soon: 'Wkrótce dostępne',
  toast_portal: 'Przekierowanie do portalu wiedzy…',
  toast_added: 'Plik dodany',
  toast_saved: 'Zapisano zmiany',
  toast_pass: 'Otwieram zmianę hasła…',
  toast_deleted: 'Plik usunięty',
  verify_email_banner: 'Potwierdź adres e-mail, aby uzyskać dostęp do dokumentacji medycznej.',
  verify_email_cta: 'Wyślij link potwierdzający',
  verify_email_sent: 'Link wysłany na Twój e-mail.',
  verify_email_title_existing: 'Potwierdź e-mail i ustaw hasło',
  verify_email_sub_existing: 'Na Twoim koncie mamy już adres e-mail. Potwierdź go i ustaw hasło, aby logować się nie tylko kodem SMS, ale też e-mailem.',
  set_new_password_title: 'Ustaw nowe hasło',
  set_new_password_sub: 'Wpisz nowe hasło do swojego konta',
  new_password_placeholder: 'Nowe hasło (min. 8 znaków)',
  confirm_password_placeholder: 'Powtórz nowe hasło',
  set_password_btn: 'Zapisz hasło',
  password_set_success: 'Hasło zostało pomyślnie zmienione! Trwa logowanie...',
  err_password_short: 'Hasło musi mieć co najmniej 8 znaków.',
  err_passwords_mismatch: 'Podane hasła nie są identyczne',
  my_account: 'Moje konto',
  passport_no: 'Seria i numer paszportu',
  issue_country: 'Kraj wydania',
  issue_date: 'Data wydania',
  building: 'Numer domu/lokalu',
  zipcode: 'Kod pocztowy',
  email: 'E-mail',
  push_notif: 'Powiadomienia push',
  push_off_toast: 'Powiadomienia wyłączone',
  push_on_toast: 'Powiadomienia włączone',
  push_err_toast: 'Błąd aktywacji powiadomień',
  turn_off: 'Wyłącz',
  turn_on: 'Włącz',
  add_email_title: 'Dodaj adres e-mail do konta',
  add_email_sub: 'Twoje konto jest zarejestrowane tylko przez telefon. Dodaj e-mail, aby móc się zalogować i odzyskać hasło.',
  add_email_btn: 'Dodaj e-mail',
  err_email_send: 'Błąd wysyłania e-maila. Spróbuj ponownie.',
  terms_link: 'Zapoznaj się z <u>Regulaminem Serwisu</u>',
  privacy_link: 'Zapoznaj się z <u>Polityką Prywatności</u>',
  error_save: 'Wystąpił błąd podczas zapisywania',
  sending: 'Wysyłanie...',
  poland: 'Polska',
  ther_welcome_sub: 'Poniżej znajdziesz wszystko, czego potrzebujesz w terapii odchudzania lekami GLP-1',
  ther_next_visit: 'Następna wizyta kontrolna',
  ther_rec_date: 'Zalecany termin:',
  ther_book_visit: 'Umów wizytę kontrolną',
  ther_my_visits: 'Moje konsultacje',
  ther_visits_desc: 'Historia i nadchodzące konsultacje',
  ther_tests: 'Badania kontrolne',
  ther_tests_desc: 'Zrób specjalny pakiet badań dla terapii w Synevo - 299 zł',
  ther_portal: 'Portal wiedzy o terapii',
  ther_portal_desc: 'Jak stosować preparaty, o odżywianiu i aktywności fizycznej',
  ther_extra_services: 'Dodatkowe usługi',
  ther_extra_services_desc: 'Zamów konsultacje z dietetykiem, plan żywieniowy',
  doc_delete_err: 'Nie udało się usunąć pliku',
  doc_delete_btn: 'Usuń',
  thanks_desc: 'Twoja dyspozycja została przyjęta. O kolejnych krokach poinformujemy Cię drogą mailową oraz w powiadomieniach.',
  thanks_no_order: 'Dziękujemy za zamówienie! Szczegóły znajdziesz w swoim koncie.',
  back_to_dashboard: 'Wróć do kokpitu',
  sick_note_from_to: '<span style="font-size: 12px;">z</span> {from} <span style="font-size: 12px;">po</span> {to}',
  err_load_slots: 'Wystąpił błąd podczas ładowania terminów.',
  err_resch: 'Błąd podczas zmiany terminu.',
  resch_ok_p1: 'Twoja wizyta została przeniesiona na {date}.',
  resch_ok_p2: 'Potwierdzenie wysłaliśmy na e-mail.',
  med_cons: 'Konsultacja medyczna',
  loading_slots: 'Ładowanie terminów…',
  no_avail_slots: 'Brak dostępnych terminów',
  resch_new_time: 'Twój nowy termin',
  any_doctor: 'Dowolny lekarz',
  doc_placeholder: 'Lekarz',
  resch_select_date: 'Wybierz',
  weekdays_short: 'Pon,Wt,Śr,Czw,Pt,Sob,Ndz',
  synevo_any_point: 'Wykonaj w dowolnym punkcie Synevo',
  pwa_banner_title: 'Zainstaluj aplikację',
  pwa_banner_sub: 'Dodaj aplikację na ekran główny, i <strong>odbierz -15%</strong> na pierwsze zamówienie z aplikacji',
  pwa_banner_how: 'Jak zainstalować?',
  pwa_exp_title: 'Zainstaluj aplikację',
  pwa_exp_sub: 'Zainstaluj aplikację, <strong>odbierz -15% na zamówienie</strong> i korzystaj z dodatkowych bonusów oraz powiadomień',
  pwa_welcome_coupon: 'Hej! Odbierz -15% na pierwsze zamówienie z aplikacji z kodem <b>WELCOME15</b>',
  pwa_back: 'Wstecz',
  pwa_s_1: '1. Naciśnij przycisk na dole ekranu',
  pwa_s_2: '2. Następnie naciśnij przycisk',
  pwa_s_2_badge: 'Udostępnij',
  pwa_s_3: '3. Przewiń menu i wybierz',
  pwa_s_3_badge: 'Dodaj do ekranu głównego',
  pwa_s_4: '4. Wprowadź nazwę i naciśnij przycisk',
  pwa_s_4_badge: 'Dodaj',
  pwa_s_4_end: 'w prawym górnym rogu',
  pwa_ci_1: '1. Naciśnij przycisk u góry ekranu',
  pwa_ci_1_mid: 'lub znajdź przycisk',
  pwa_ci_1_badge: 'Pokaż więcej',
  pwa_ca_1: '1. Naciśnij menu',
  pwa_ca_1_end: 'w prawym górnym rogu',
  pwa_ca_3: '3. Potwierdź, naciskając',
  pwa_ca_3_badge1: 'Zainstaluj',
  pwa_ca_3_mid: 'lub',
  pwa_ca_3_badge2: 'Dodaj',
  tour_back: 'Powrót',
  tour_next: 'Dalej',
  tour_finish: 'Zakończ',
  tour_welcome: 'Cześć! Witamy w Twoim koncie pacjenta 👋 W kilku krokach pokażemy, co i gdzie znajdziesz.',
  tour_notif: 'Tu są Twoje powiadomienia — damy znać, gdy pojawią się wyniki badań, nowe dokumenty lub zalecenia lekarza.',
  tour_a1: 'Tu przypomnimy o zalecanym terminie wizyty kontrolnej — umówisz ją jednym kliknięciem.',
  tour_a2: 'W «Moje konsultacje» znajdziesz pełną historię wizyt, przełożysz termin i umówisz kolejną. Otworzysz tam też podsumowanie każdej wizyty — zalecenia lekarza i dokumenty.',
  tour_a3: 'W zakładce «Usługi» zamówisz nasze dodatkowe usługi poza terapią — e-receptę, teleporadę, L4 czy pakiet badań.',
  tour_a4: 'W «Dokumenty» są Twoje recepty, skierowania, zalecenia lekarza i wyniki badań. Możesz też dodać własny plik.',
  tour_a5: 'W «Moje dane» zmienisz swoje dane, ustawisz hasło do logowania i zmienisz ustawienia konta.',
  tour_b1: 'W «Umów się» zamówisz e-receptę, teleporadę, L4, antykoncepcję lub pakiet badań.',
  tour_b2: 'W «Konsultacje» znajdziesz historię wizyt i zamówień, przełożysz termin, a także otworzysz podsumowanie wizyty — zalecenia lekarza i dokumenty.',
  tour_b3: 'W «Dokumenty» są Twoje recepty, zwolnienia, skierowania i wyniki badań.',
  tour_b4: 'W «Moje dane» zmienisz swoje dane, ustawisz hasło do logowania i zmienisz ustawienia konta.',
  tour_pwa: 'Zainstaluj konto jako aplikację na ekranie głównym telefonu — otworzysz je jednym dotknięciem, jak zwykłą apkę.',
  loading_dots: 'Załadunek...',
  err_login_invalid: 'Nieprawidłowy adres e-mail lub hasło',
  email_placeholder: 'E-mail*',
  show_hide_password: 'Pokaż/ukryj hasło',
  err_email_invalid: 'Podaj prawidłowy adres e-mail.',
  err_firstname_latin: 'Proszę wpisać imię alfabetem łacińskim (np. Natalia).',
  err_lastname_latin: 'Prosimy o wpisanie nazwiska bez spacji i alfabetem łacińskim (np. Kovalchuk).',
  err_email_exists: 'Ten adres e-mail jest już zajęty.',
  err_rate_limit_10m: 'Zbyt wiele prób. Odczekaj 10 minut.',
  err_register_failed: 'Rejestracja nie powiodła się. Spróbuj ponownie.',
  err_reset_send: 'Błąd podczas wysyłania linku.',
  powrot: 'Powrót',
  reset_pw_sub: 'Wpisz e-mail, aby zresetować hasło.',
  err_set_password: 'Błąd podczas ustawiania hasła. Link mógł wygasnąć.',
  auth_ready: 'Gotowe!',
  auth_redirect_msg: 'Konto zostało założone pomyślnie. Za chwilę zostaniesz przekierowany...',
  push_prompt_msg: 'Czy chcesz włączyć powiadomienia push, aby nie przegapić ważnych informacji?',
  notifications: 'Powiadomienia',
  no_notifications: 'Brak powiadomień',
  err_phone_min9: 'Podaj prawidłowy numer telefonu (min. 9 cyfr)',
  err_street_invalid: 'Podaj poprawną nazwę ulicy',
  err_city_invalid: 'Podaj poprawną nazwę miasta',
  house_number: 'Numer domu/lokalu',
  zip_code: 'Kod pocztowy',
  empty_cons_btn: 'Umów wizytę',
  empty_cons_title: 'Nie masz jeszcze wizyt',
  dr_prefix: 'Lek.',
  synevo_package: 'Pakiet badań w Synevo',
  blood_tests_package: 'Pakiet badań krwi',
  doctor_alt: 'Lekarz',
  err_fetch_recommendations: 'Nie udało się pobrać zaleceń',
  doctor_recommendations: 'Zalecenia lekarza',
  dietitian_recommendations: 'Zalecenia dietetyka',
  visit_no: 'Wizyta',
  no_recommendations: 'Brak zaleceń dla tej wizyty.',
  err_upload_file: 'Błąd podczas wgrywania pliku',
  no_visit_data: 'Brak danych o wizycie.',
  diagnosis: 'Diagnoza',
  e_prescription: 'E-recepta',
  e_prescription_code: 'Kod e-recepty:',
  referrals_title: 'Skierowania',
  code_label: 'Kod:',
  test_results_docs: 'Wyniki badań / Dokumenty',
  password_placeholder: 'Hasło*',
  prescription_title: 'Recepta',
  referral: 'Skierowanie',
  print_save_pdf: 'Drukuj / Zapisz PDF',
  close: 'Zamknij',
  push_later: 'Później',
  doc_referral_title: 'Skierowanie',
  doc_referral_code: 'Kod e-skierowania',
  doc_referral_type: 'Rodzaj skierowania',
  doc_referral_diseases: 'Rozpoznania',
  doc_referral_procedures: 'Badania / Procedury',
  doc_referral_reason: 'Powód skierowania',
  doc_referral_notes: 'Uwagi dodatkowe',
  doc_referral_urgent: 'Pilne',
  doc_referral_empty: 'Brak skierowań dla tej wizyty.',
  doc_referral_card_label: 'Skierowanie',
  diet_need_advice: 'Potrzebujesz porady dietetyka?',
  diet_need_advice_sub: 'Skonsultuj się z naszym ekspertem lub zamów indywidualny jadłospis dostosowany do Twoich potrzeb.',
  diet_check_offer: 'Sprawdź ofertę',
  diet_plan_title: 'Twój plan żywieniowy',
  diet_plan_ready: 'Gotowy',
  diet_plan_prep: 'W przygotowaniu',
  diet_plan_prep_desc: 'Dietetyk przygotowuje Twój jadłospis. Damy znać e-mailem (zwykle do 2 dni).',
  diet_plan_slot: '📅 Umówiona konsultacja: {slot}',
  diet_plan_desc: 'Jadłospis na 30 dni od dietetyka — z przepisami i listą zakupów.',
  diet_plan_open: 'Otwórz plan',
  diet_plan_download: 'Pobierz PDF',
  diet_plan_reorder: 'Zamów kolejny miesiąc (99 zł)',
  diet_plan_meet: 'Konsultacja: Google Meet',
  diet_plan_zalecenia: 'Zalecenia od dietetyka:',
};
